<div *ngIf="mobile.isMobileDisplay()" class="hide-for-medium">
  <button class="clear button margin-0" (click)="isSearchOpen = true" *ngIf="!isSearchOpen" type="button">
    <rav-icon name="magnifying-glass" class="page__icon--large"></rav-icon>
  </button>
</div>
<div
  class="global-search"
  *ngIf="isSearchOpen || !mobile.isMobileDisplay()"
  [ngClass]="emptySearch ? 'extra-margin' : ''"
>
  <div class="global-search__box">
    <form (ngSubmit)="submitSearch(search.value)" [formGroup]="formGroup" class="grid-x align-middle">
      <div class="cell shrink hide-for-medium" *ngIf="mobile.isMobileDisplay()">
        <button class="clear button global-search__back" (click)="isSearchOpen = false" type="button">
          <i class="fa fa-chevron-left"></i>
        </button>
      </div>
      <div class="cell auto medium-5 large-3">
        <div class="input-group margin-bottom-0 ">
          <input
            #search
            formControlName="search"
            type="search"
            class="input-group-field global-search__input"
            placeholder="Search Here..."
            data-cy="global-search"
            required
          />

          <div class="global-search__position">
            <button class="global-search__clear" type="reset"><rav-icon name="cancel"></rav-icon></button>
          </div>
          <button
            type="submit"
            class="global-search__button input-group-button button"
            data-cy="global-search__submit"
            [ngClass]="mobile.isMobileDisplay() ? '' : 'secondary'"
          >
            <rav-icon class="global-search__icon" name="magnifying-glass"></rav-icon>
          </button>
        </div>
      </div>
      <div class="cell small-12 medium-shrink">
        <a *ngIf="!router.url.includes('/search')" routerLink="/search" class="global-search__advanced">
          Advanced Search
        </a>
      </div>
      <div class="cell small-12">
        <div *ngIf="emptySearch" class="global-search__empty">Enter keywords to search</div>
      </div>
    </form>
  </div>
</div>
